import React from 'react';
import { useNavigate } from 'react-router-dom';
import MetricCard from './MetricCard';

export const RadiologistCommandCenter = ({ stats, loading, activeCentreName }) => {
  const navigate = useNavigate();

  const radio = stats?.radiology || {};

  return (
    <div className="lis-command-deck radiologist-deck">
      {/* 1. Radiology Operational Overview */}
      <div className="lis-deck-section">
        <div className="lis-section-header-compact">
          <div className="lis-section-header-left">
            <span className="lis-section-kicker">IMAGING & RADIOLOGY</span>
            <h3 className="lis-section-title">Scan Worklist & Dictation Status</h3>
            <span className="lis-section-sub">&bull; {activeCentreName}</span>
          </div>
          <div className="lis-deck-actions">
            <button
              type="button"
              className="lis-deck-action-primary"
              onClick={() => navigate('/radiology-results')}
            >
              Radiology Workstation
            </button>
            <button
              type="button"
              className="lis-deck-quick-btn"
              onClick={() => navigate('/masters/radiology-templates')}
            >
              Templates
            </button>
          </div>
        </div>

        <div className="lis-kpi-grid">
          <MetricCard
            title="Imaging Studies Pending"
            value={radio.pendingResults ?? 0}
            subtitle="Scans awaiting reporting"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/radiology-results"
            variant={radio.pendingResults > 0 ? 'warning' : 'success'}
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            }
          />

          <MetricCard
            title="Draft Reports Saved"
            value={radio.drafts ?? 0}
            subtitle="Incomplete dictations"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/radiology-results"
            variant="info"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            }
          />

          <MetricCard
            title="Studies Completed Today"
            value={radio.approvedToday ?? 0}
            subtitle="Digitally finalized scans"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/radiology-results"
            variant="success"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            }
          />

          <MetricCard
            title="Total Modality Orders"
            value={radio.totalToday ?? 0}
            subtitle="Today's imaging registrations"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/radiology-results"
            variant="default"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 14 14" />
              </svg>
            }
          />
        </div>
      </div>

      {/* 2. Modality Queues & Quick Actions */}
      <div className="lis-deck-section">
        <h4 className="lis-sub-section-title">Radiological Modalities & Workbenches</h4>
        <div className="lis-work-tasks-grid">
          <div className="lis-task-card" onClick={() => navigate('/radiology-results')}>
            <div className="lis-task-badge warning">
              {radio.pendingResults ?? 0} STUDIES AWAITING READ
            </div>
            <h5 className="lis-task-title">X-Ray, Ultrasound & CT Reporting</h5>
            <p className="lis-task-desc">
              Review DICOM imaging studies, apply specialized reporting templates, input findings, and sign off.
            </p>
            <span className="lis-task-link">Open Radiology Worklist &rarr;</span>
          </div>

          <div className="lis-task-card" onClick={() => navigate('/masters/radiology-templates')}>
            <div className="lis-task-badge info">ORGANIZED</div>
            <h5 className="lis-task-title">Standardized Impression Templates</h5>
            <p className="lis-task-desc">
              Configure anatomical reporting templates, macros, and standard normal findings for fast dictation.
            </p>
            <span className="lis-task-link">Manage Templates &rarr;</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadiologistCommandCenter;
